import AboutList from '../Data/About'
import Lottie from "lottie-react";
import MemegorWhite from "../lottie-loop/mg-icon-loop-white.json";

function About(props) {
    
    return (
        <>
        {AboutList.map((About) => (
        <div className="py-32">
            <div className="flex flex-row justify-between w-full gap-20 relative">
                <div>
                    <div className=" md:text-5xl text-3xl font-mono py-10">About <br /> Meme Goreng</div>
                </div>
                <a href="/">
                <div className=" hover:scale-125 duration-500">
                    <div
                        className=" bg-red-600 rounded-full xl:w-96 xl:h-96 lg:w-72 lg:h-72 md:w-64 md:h-64 w-48 h-48 absolute lg:right-16 md:right-10 right-0">
                        <Lottie animationData={MemegorWhite} loop="true" className="w-full h-full object-cover px-5 py-5" />
                    </div>
                </div>
                </a>
            </div>
            <div className="py-10 max-w-7xl">
                <div className="md:text-4xl text-2xl font-mono leading-relaxed xl:pr-96 md:pr-64">
                    {About.desc}
                </div>
            </div>
            <div className="w-full h-full rounded-3xl py-10">
                <video src={About.video} controls="true" loop="true" muted="true" className="w-full h-full rounded-3xl" />
            </div>
            <div className="grid lg:grid-cols-2 grid-cols-1 gap-10 py-10">
                <div className="w-full h-full md:text-3xl text-3xl font-mono">
                    <div className="">MEME GORENG 3018 IS LOCATED AT</div>
                    <a href={About.locationLink}>
                    <div className="font-bold hover:translate-x-6 duration-500 truncate"><i>{About.location}</i></div>
                    </a>
                </div>

                <div className="w-full h-full md:text-3xl text-3xl font-mono">
                    <div className="">SAY HI OR SHARE SOME MEMES TO</div>
                    <a href={About.emailLink}>
                    <div className="font-bold hover:translate-x-6 duration-500 truncate"><i>{About.email}</i></div>
                    </a>
                </div>

                <div className="w-full h-full md:text-3xl text-3xl font-mono">
                    <div className="">LIKE US ON</div>
                    <a href={About.likeUsLink}>
                    <div className="font-bold hover:translate-x-6 duration-500"><i>{About.likeUs}</i></div>
                    </a>
                </div>

                <div className="w-full h-full md:text-3xl text-3xl font-mono">
                    <div className="">FOLLOW US ON</div>
                    <a href={About.followUsLink}>
                    <div className="font-bold hover:translate-x-6 duration-500"><i>{About.followUs}</i></div>
                    </a>
                </div>

                <div className="w-full h-full md:text-3xl text-3xl font-mono">
                    <div className="">FIND US ON</div>
                    <a href={About.findUsLink}>
                    <div className="font-bold hover:translate-x-6 duration-500"><i>{About.findUs}</i></div>
                    </a>
                </div>

                <div className="w-full h-full md:text-3xl text-3xl font-mono">
                    <div className="">OUR PAGE IS OPEN</div>
                    <a href="https://www.facebook.com/memegoreng3018/">
                    <div className="font-bold hover:translate-x-6 duration-500"><i>07AM—05PM <br /> MONDAY TO SUNDAY.</i></div>
                    </a>
                </div>


            </div>

        </div>
        ))}
        </>
    )
}

export default About;